import { defineComponent as _defineComponent } from 'vue'

import Icon from "../icons/Icon.vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'StateChip',
  props: {
    state: null,
    color: null,
    icon: null,
    iconType: null
  },
  setup(__props: any) {



return { __sfc: true,Icon }
}

})